import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import { httpAdmin } from "../../../Apis/commonApis";
import swal from "sweetalert";

function ActivityFormModel({
  openActivityModal,
  handleModalClose,
  editActivityData,
  clientId,
}) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      category: editActivityData?.category || "",
      activityType: editActivityData?.activityType || "",
      notes: editActivityData?.notes || "",
    },
  });

  const userData = JSON.parse(localStorage.getItem("userData"));
  const CategoryData = ["Admin", "Council", "Finance", "Care"];
  const ActivityTypeData = ["Email", "Meeting", "Call", "Task"];

  useEffect(() => {
    if (editActivityData) {
      setValue("category", editActivityData?.category);
      setValue("activityType", editActivityData?.activityType);
      setValue("notes", editActivityData?.notes);
      console.log(editActivityData, "editActivityData");
    }
  }, [editActivityData]);

  const onAddEditContactSubmit = async (data) => {
    let apiUrl = `createClientActivity`;
    let method = "post";

    if (editActivityData?._id) {
      apiUrl = `updateClientActivity/${editActivityData?._id}`;
    }
    const payload = {
      ...data,
      careHomeId: currentCareSiteId,
      clientId: clientId,
      createdBy: userData?._id,
    };

    try {
      // Add error handling.  Wrap the API call in a try/catch block.
      const result = await httpAdmin(apiUrl, method, payload, null);
      handleModalClose("refresh");
      swal(
        result.status ? "Success" : "Failed",
        result.message,
        result.status ? "success" : "error"
      );
    } catch (error) {
      console.error("API Error:", error);
      handleModalClose(); // Still close the modal on error
      swal("Error", "An error occurred while saving data.", "error");
    }
  };

  return (
    <Modal show={openActivityModal} onHide={handleModalClose}>
      <Modal.Body>
        <div aria-labelledby="exampleModalLabel" aria-hidden="true">
          <form onSubmit={handleSubmit(onAddEditContactSubmit)}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {editActivityData ? "Edit" : "Add"} Activity
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleModalClose}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="form-label">Category</label>
                    <select
                      className="form-control"
                      {...register("category", {
                        required: true,
                      })}
                    >
                      <option value="">Select Category</option>
                      {CategoryData.map((category) => (
                        <option key={category} value={category}>
                          {category}
                        </option>
                      ))}
                    </select>
                    {errors?.category?.type === "required" && (
                      <p className="error_style">This field is required</p>
                    )}
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label">Activity Type</label>
                    <select
                      className="form-control"
                      {...register("activityType", {
                        required: true,
                      })}
                    >
                      <option value="">Select Activity Type</option>
                      {ActivityTypeData.map((activityType) => (
                        <option key={activityType} value={activityType}>
                          {activityType}
                        </option>
                      ))}
                    </select>
                    {errors?.activityType?.type === "required" && (
                      <p className="error_style">This field is required</p>
                    )}
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label">Notes</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("notes")}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-success">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ActivityFormModel;
